import { REAGION_SOATO } from '@/common/constants/regions';
import useStore from '@/lib/store';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  regionId?: string;
  districtId?: string;
  districtName?: string;
};

export const NavigateTitle: FC<Props> = ({ regionId, districtId, districtName }) => {
  const [areaName, setAreaName] = useState<string>('respublic');
  const { t } = useTranslation();
  const { district, fetchDistrict } = useStore();

  useEffect(() => {
    if (districtId && regionId && !districtName) {
      // Fetch districts if not already loaded and districtName not provided
      if (district.length === 0) {
        fetchDistrict({ region_id: regionId });
      }
    }
  }, [districtId, regionId, districtName, district.length]);

  useEffect(() => {
    if (districtName) {
      // Use provided district name (from employees data)
      setAreaName(districtName);
    } else if (districtId && district.length > 0) {
      // Find district name from store
      const districtData = district.find((item) => item.id === districtId);
      if (districtData) {
        setAreaName(districtData.name_uz);
      } else {
        setAreaName('respublic');
      }
    } else if (regionId) {
      // Find region name
      setAreaName(
        String(REAGION_SOATO?.find((item) => item.id === regionId)?.name),
      );
    } else {
      setAreaName('respublic');
    }
  }, [regionId, districtId, districtName, district]);

  const displayName = areaName ? t(areaName) : t('respublic');

  return (
    <div className="flex items-center gap-5">
      <p className="text-xl font-semibold">
        {displayName} {t('crop.stewardship')}
      </p>
    </div>
  );
};

